export const analyticsAttributes = {
	proactiveGeneratedAI: 1,
	userGeneratedAI: 0,
	isAIFeature: 1,
	inProductExperience: 'jsmComposer',
};

export const ROVO_CREATE_VIEW_SPACE_SOURCE = 'rovo-create-view-space';
